import React from 'react'

import DatePicker from '../components/controls/DatePicker'
import RemoveButton from '../components/controls/RemoveButton'
import TimeEntry from '../components/controls/TimeEntry'

import ActivityExpenseSelector from './ActivityExpenseSelector'
import CustomDropDown from './CustomDropDown'
import RecordReviewDescriptionSelect from './RecordReviewDescriptionSelect'

const Activity = ({
  namePrefix,
  model,
  setModelFunction,
  createInputProps,
  ErrorMessage,
  handleRemove,
  allowEditing = true,
  onMoveUp,
  onMoveDown,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  children,
  caseMemberOptions = [],
}) => {
  const typeProps = createInputProps({ name: `${namePrefix}.type`, model, setModelFunction })
  const descProps = createInputProps({ name: `${namePrefix}.description`, model, setModelFunction })

  return (
    <div
      className="activity clearfix"
      draggable={allowEditing}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      style={
        allowEditing
          ? {
              border: '1px dashed #ccc',
              padding: '10px',
              marginBottom: '10px',
              borderRadius: '4px',
              background: '#fafafa',
            }
          : {}
      }
    >
      <div className="form-row">
        {/* Date — col-md-2 */}
        <div className="col-md-2">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.date`}>
              Date
            </label>
            <DatePicker
              readOnly={!allowEditing}
              className="form-control"
              {...createInputProps({ name: `${namePrefix}.date`, model, setModelFunction })}
            />
          </div>
        </div>

        {/* Type of Activity — col-md-2 */}
        <div className="col-md-2" style={{ minWidth: 0 }}>
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.type`}>
              Type of Activity
            </label>
            <ActivityExpenseSelector
              allowEditing={allowEditing}
              className="form-control"
              {...typeProps}
              type="activity"
            />
          </div>
        </div>

        {/* Time — col-md-1 */}
        <div className="col-md-1">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.time`}>
              Time
            </label>
            <TimeEntry
              allowEditing={allowEditing}
              {...createInputProps({ name: `${namePrefix}.time`, model, setModelFunction })}
            />
          </div>
        </div>

        {/* Description — col-md-4 */}
        <div className="col-md-4">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.description`}>
              Description
            </label>
            {typeProps.value === 'Record Review' ? (
              <RecordReviewDescriptionSelect allowEditing={allowEditing} {...descProps} />
            ) : (
              <input readOnly={allowEditing ? null : true} className="form-control" {...descProps} />
            )}
          </div>
        </div>

        {/* Case Member — col-md-2 */}
        <div className="col-md-2">
          <div className="form-group">
            <label className="form-label mt-2 d-md-none" htmlFor={`${namePrefix}.userId`}>
              Case Member
            </label>
            <CustomDropDown
              id={`${namePrefix}.userId`}
              name={`${namePrefix}.userId`}
              allowEditing={allowEditing}
              className="drop-down-container"
              items={caseMemberOptions}
              placeholderText="Select Member"
              noOptionsMessage="No members found"
              {...createInputProps({
                name: `${namePrefix}.userId`,
                model,
                setModelFunction,
              })}
            />
          </div>
        </div>

        {/* Actions — col-md-1 */}
        <div className="col-md-1">
          <div className="form-group">
            <div className="form-label mt-2 d-md-none">&nbsp;</div>
            <div className="d-flex align-items-center justify-content-end" style={{ height: '38px' }}>
              {allowEditing && (
                <div className="d-flex align-items-center hide-sm-down">
                  {onMoveUp && (
                    <button
                      type="button"
                      className="btn btn-link p-1 text-secondary"
                      style={{ fontSize: '1.2rem', textDecoration: 'none' }}
                      title="Move Up"
                      onClick={onMoveUp}
                    >
                      ▲
                    </button>
                  )}
                  {onMoveDown && (
                    <button
                      type="button"
                      className="btn btn-link p-1 text-secondary"
                      style={{ fontSize: '1.2rem', textDecoration: 'none' }}
                      title="Move Down"
                      onClick={onMoveDown}
                    >
                      ▼
                    </button>
                  )}
                  <span
                    className="mx-2 text-muted drag-handle"
                    style={{ cursor: 'grab', userSelect: 'none', fontSize: '1.2rem', paddingBottom: '3px' }}
                    title="Drag to reorder"
                  >
                    ⋮⋮
                  </span>
                  <RemoveButton id={`${namePrefix}RemoveBtn`} onClick={handleRemove} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-2">
        <ErrorMessage name={`${namePrefix}.date`} model={model} />
        <ErrorMessage name={`${namePrefix}.type`} model={model} />
        <ErrorMessage name={`${namePrefix}.time`} model={model} />
        <ErrorMessage name={`${namePrefix}.userId`} model={model} />
        <ErrorMessage name={`${namePrefix}.description`} model={model} />
      </div>
      {children}
      {allowEditing && (
        <div className="show-sm-down clearfix">
          {onMoveUp && (
            <button type="button" className="btn btn-link float-left text-secondary" onClick={onMoveUp}>
              Move Up ▲
            </button>
          )}
          {onMoveDown && (
            <button type="button" className="btn btn-link float-left text-secondary" onClick={onMoveDown}>
              Move Down ▼
            </button>
          )}
          <RemoveButton id={`${namePrefix}.RemoveBtn-Large`} className="float-right" onClick={handleRemove}>
            Remove
          </RemoveButton>
        </div>
      )}
    </div>
  )
}

export default Activity
